export default "/static/webpack/media/undraw_hiring.f6b26c80.svg";